"use client";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Atmosphere from "@/components/v6/Atmosphere";
import Incipit from "@/components/v6/Incipit";
import IlluminatedVerse from "@/components/v6/IlluminatedVerse";
import QueriesAnswered from "@/components/v6/QueriesAnswered";
import ProductPanels from "@/components/v6/ProductPanels";
import Manifesto from "@/components/v6/Manifesto";
import Readers from "@/components/v6/Readers";
import Colophon from "@/components/v6/Colophon";

/* ————— v6 "Illumination" homepage —————
   One continuous illuminated page over a persistent Atmosphere layer.
   Order set 2026-07-10 per Jay's review: context first, then the
   asked-and-answered proof.

   1. Incipit          — hero; the lamp finds the manuscript
   2. IlluminatedVerse — the showpiece: apparatus blooms in the margins
   3. QueriesAnswered  — real queries slide in; one gets its real answer
   4. ProductPanels    — the app as large, legible UI panels
   5. Manifesto        — full-vellum; the one full-light moment
   6. Readers          — typographic triptych
   7. Colophon         — FAQ + the scribe's closing note (download)
*/

export default function HomePageClient() {
  return (
    <>
      <Header />
      <Atmosphere />
      <main className="relative z-10 min-h-screen overflow-x-clip">
        <Incipit />
        <IlluminatedVerse />
        <QueriesAnswered />
        <ProductPanels />
        <Manifesto />
        <Readers />
        <Colophon />
      </main>
      <div className="relative z-10">
        <Footer />
      </div>
    </>
  );
}
